/**
 * Generates a dicebear avatar URL for a given username
 * @param username - The username to use as seed for the avatar
 * @returns The complete avatar URL
 */
export const generateAvatarUrl = (username: string): string => {
  return `https://api.dicebear.com/9.x/bottts/svg?seed=${encodeURIComponent(username)}`;
};

/**
 * Gets the avatar URL for a user, falling back to dicebear if no profileImageUrl is provided
 * @param profileImageUrl - The user's existing profile image URL (can be null)
 * @param username - The username to use for generating a fallback avatar
 * @returns The avatar URL to use
 */
export const getAvatarUrl = (profileImageUrl: string | null | undefined, username: string): string => {
  return generateAvatarUrl(username);
};
